import { render, staticRenderFns } from "./ShainTorokuJocho.vue?vue&type=template&id=2ffe4902&scoped=true"
import script from "./ShainTorokuJocho.vue?vue&type=script&lang=js"
export * from "./ShainTorokuJocho.vue?vue&type=script&lang=js"
import style0 from "./ShainTorokuJocho.vue?vue&type=style&index=0&id=2ffe4902&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffe4902",
  null
  
)

export default component.exports